import { FC } from 'react';

export const DrawerClose: FC = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="安装商" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="添加用户-角色选择" transform="translate(-1092.000000, -20.000000)">
                <g id="Group" transform="translate(1060.000000, 0.000000)">
                    <g id="01icon/close" transform="translate(32.000000, 20.000000)">
                        <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="24" height="24"></rect>
                        <path
                            d="M18,6 L6,18 M6,6 L18,18"
                            id="Combined-Shape"
                            strokeOpacity="0.920618444"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
